<template>
  <div class="wrapper">
    <div class="main-container">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    // console.log(this.$store.state.breadCrumb);
  },
  computed: {
    breadCrumb: function () {
      return this.$store.state.breadCrumb;
    },
  },
};
</script>
<style scoped>
.wrapper{height:calc(100% - 66px);}
.main-container {
  height:100%;
  background: #fff;
  margin-top: 8px;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
  border-radius:3px;
  padding:20px;
}
</style>